<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { checkbox } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';
  import formatarData from '~js/formatar-data';
  import atividadeServico from '~modulos/atividade/servico';
  import tipoCertidaoServico from '~modulos/certidao/servico';
  import tiposConta from '~js/tipos-conta';
  import tiposPessoaConta from '~js/tipos-pessoa-conta';
  import bancoServico from '~modulos/banco/servico';

  export default {
    components: { checkbox },
    props: {
      pessoa: {
        type: Object,
        required: true,
      },
      arquivos: {
        type: Array,
        required: true,
      },
      arquivosNaoSalvos: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        responsavelAlteracao: {
          cpf: '',
          nome: '',
          email: '',
          aceite: false,
        },
        tiposConta: tiposConta,
        tiposPessoaConta: tiposPessoaConta,
        bancos: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");

        return this.$validator.validateAll();
      },
      nomeTipoConta(tipo) {
        tipo = tipo !== -1 ? tipo : -1;
        if (tipo == -1) {
          return "---";
        } else {
          return this.tiposConta.find(tipoConta => {
            return tipoConta.id === tipo;
          }).nome;
        }
      },
      nomeTipoPessoaConta(tipoPessoa) {
        tipoPessoa = tipoPessoa ? tipoPessoa : 0;
        if (tipoPessoa == 0) {
          return "---";
        } else {
          return this.tiposPessoaConta.find(tipoPessoaConta => {
            return tipoPessoaConta.id === tipoPessoa;
          }).nome;
        }
      },
      nomeBanco(id) {
        return this.bancos.find(banco => {
          return banco.idBanco === id;
        }).nome;
      },
      numeroBanco(id) {
        return this.bancos.find(banco => {
          return banco.idBanco === id;
        }).numero;
      },
      carregarBancos() {
        return bancoServico.
          lista()
          .then(bancos => {
            this.bancos = bancos;
            this.bancosAtivos = bancos.filter(banco => banco.disponibilizarWEB);
          });
      },
      preencherResponsavel() {
        this.responsavelAlteracao.cpf = this.pessoa.cpfCnpj;
        this.responsavelAlteracao.nome = this.pessoa.nomePessoaFisicaJuridica;
        this.responsavelAlteracao.email = this.pessoa.email;
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      gerarObjetoDeDados() {
        const obj = {
          dadosGerais: {
            cpf: this.pessoa.cpfCnpj || '---',
            identidade: this.pessoa.identidadeInscEstadual || '---',
            nome: this.pessoa.nomePessoaFisicaJuridica || '---',
            inss: this.pessoa.inss || '---',
            pispasep: this.pessoa.pisPasep || '---',
            endereco: this.enderecoPessoa,
          },
          contatos: {
            telefone1: this.pessoa.telefone1 || '---',
            telefone2: this.pessoa.telefone2 || '---',
            fax: this.pessoa.fax || '---',
            email: this.pessoa.email || '---',
          },
          referenciaBancaria: this.pessoa.dadosBancarios.map((dadoBancario) => ({
            banco: `${this.nomeBanco(dadoBancario.idBanco)} - ${dadoBancario.numeroBanco}`,
            agencia: dadoBancario.numeroAgencia,
            numeroConta: dadoBancario.numeroConta,
            tipoConta: this.nomeTipoConta(dadoBancario.tipoConta),
            tipoPessoa: this.nomeTipoPessoaConta(dadoBancario.tipoPessoa)
          })),
          outrosArquivos: [...this.arquivos, ...this.arquivosNaoSalvos],
          aceiteTermoResponsabilidade: 
             `Eu, ${this.responsavelAlteracao.nome || '<< SEM NOME >>'}, portador do documento CPF nº ${this.responsavelAlteracao.cpf || '<< SEM CPF >>'} e contato de e-mail ${this.responsavelAlteracao.email || '<< SEM EMAIL >>'}, estou ciente e atesto as informações aqui apresentadas.`      
        };

        const newObj = {
          cpfPessoaAceite: this.responsavelAlteracao.cpf,
          nomePessoaAceite: this.responsavelAlteracao.nome,
          emailPessoaAceite: this.responsavelAlteracao.email,
          resumoAceite: JSON.stringify(obj)
        };

        return newObj;
      }
    },
    mounted() {
      this.carregarBancos();
    },
    computed: {
      enderecoPessoa() {
        let endereco = '';
        if (this.pessoa.endereco) {
          endereco = endereco + this.pessoa.endereco;
        }
        if (this.pessoa.numero) {
          endereco = endereco + ', ' + this.pessoa.numero;
        }
        if (this.pessoa.complemento) {
          endereco = endereco + ', ' + this.pessoa.complemento;
        }
        if (this.pessoa.bairro) {
          endereco = endereco + ', ' + this.pessoa.bairro;
        }
        if (this.pessoa.cidade) {
          endereco = endereco + ', ' + this.pessoa.cidade;
        }
        if (this.pessoa.estado) {
          endereco = endereco + '/' + this.pessoa.estado;
        }

        endereco = endereco + '. ';

        if (this.pessoa.cep) {
          endereco = endereco + 'CEP ' + this.pessoa.cep;
        }
        return endereco;
      },
    },
    updated() {
       this.preencherResponsavel();
    }
  }

</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <h1><b>Resumo dos dados informados</b></h1>
        <p>Verifique abaixo todos os dados informados neste cadastro.</p>
        <br />

        <h2><b>Dados gerais</b></h2>

        <div class="row">
          <dl class="col-xs-3">
            <dt>CPF</dt>
            <dd>{{ pessoa.cpfCnpj || '---'}}</dd>
          </dl>
          <dl class="col-xs-9">
            <dt>Nome</dt>
            <dd>{{ pessoa.nomePessoaFisicaJuridica || '---' }}</dd>
          </dl>
        </div>

        <div class="row">
          <dl class="col-xs-3">
            <dt>Data de nascimento</dt>
            <dd>{{ pessoa.dataNascimento || '---'}}</dd>
          </dl>
          <dl class="col-xs-3">
            <dt>Identidade</dt>
            <dd>{{ pessoa.identidadeInscEstadual || '---' }}</dd>
          </dl>
          <dl class="col-xs-3">
            <dt>INSS</dt>
            <dd>{{ pessoa.inss || '---' }}</dd>
          </dl>
          <dl class="col-xs-3">
            <dt>PISPASEP</dt>
            <dd>{{ pessoa.pisPasep || '---' }}</dd>
          </dl>
        </div>

        <div class="row">
          <dl class="col-xs-12">
            <dt>Endereço</dt>
            <dd>{{ enderecoPessoa }}</dd>
          </dl>
        </div>

        <h2><b>Contatos</b></h2>

        <div class="row">
          <dl class="col-xs-4">
            <dt>Telefone 1</dt>
            <dd>{{ pessoa.telefone1 || '---' }}</dd>
          </dl>
          <dl class="col-xs-4">
            <dt>Telefone 2</dt>
            <dd>{{ pessoa.telefone2 || '---' }}</dd>
          </dl>
          <dl class="col-xs-4">
            <dt>Fax</dt>
            <dd>{{ pessoa.fax || '---' }}</dd>
          </dl>
        </div>

        <div class="row">
          <dl class="col-xs-12">
            <dt>E-mail</dt>
            <dd>{{ pessoa.email || '---' }}</dd>
          </dl>
        </div>

        <h2><b>Referência bancária</b></h2>

        <div class="table-responsive">
          <table class="table table-hover table-pointer">
            <thead>
              <tr>
                <th>Banco</th>
                <th>Agência</th>
                <th>Número da conta</th>
                <th>Tipo de conta</th>
                <th>Tipo de pessoa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dadoBancario, indice) in pessoa.dadosBancarios">
                <td>{{ nomeBanco(dadoBancario.idBanco) }} - {{ dadoBancario.numeroBanco }}</td>
                <td>{{ dadoBancario.numeroAgencia }}</td>
                <td>{{ dadoBancario.numeroConta }}</td>
                <td>{{ nomeTipoConta(dadoBancario.tipoConta) }}</td>
                <td>{{ nomeTipoPessoaConta(dadoBancario.tipoPessoa) }}</td>
              </tr>
              <tr v-if="pessoa.dadosBancarios.length === 0">
                <td colspan="5" class="text-center">Nenhuma referência bancária informada.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="hr-line-dashed margin-top-5"></div>

        <h1><b>Termo de responsabilidade</b></h1>

        <p>
          À {{ configuracao.nomeFundacao }} - {{ configuracao.abreviaturaFundacao }} <br />
          {{ configuracao.enderecoFundacao }} - {{ configuracao.bairroFundacao }} <br />
          {{ configuracao.cepFundacao }} - {{ configuracao.cidadeFundacao }}/{{ configuracao.estadoFundacao }} <br />
          A/C: Setor de Licitação e Contratos
        </p>

        <p>
          A pessoa <b>{{ pessoa.nomePessoaFisicaJuridica }}</b>,
          inscrita no CPF sob o nº <b>{{ pessoa.cpfCnpj }}</b>,
          com residência na <b>{{ enderecoPessoa }}</b>,
          solicita a inscrição no Cadastro de Pessoa Física da {{ configuracao.abreviaturaFundacao }}.
        </p>

        <p>
          Para tal, apresentamos o presente formulário de solicitação de Cadastro de Pessoa Física,
          devidamente preenchido e verificado, juntamente com os documentos abaixo listados:
        </p>

        <h2><b>Arquivos</b></h2>

        <div class="hr-line-dashed margin-top-5"></div>

        <!--<h3><b>Arquivos</b></h3>-->
        <!-- LISTA DE ARQUIVOS -->

        <div class="table-responsive">
          <table class="table table-hover table-pointer">
            <thead>
              <tr>
                <th>Nome</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(arquivo, indice) in arquivos">
                <td>{{ nomeArquivo(arquivo) }}</td>

              </tr>

              <tr v-for="(arquivo, indice) in arquivosNaoSalvos">
                <td>{{ arquivo }}</td>

              </tr>
              <tr v-if="arquivos.length === 0 && arquivosNaoSalvos.length === 0">
                <td colspan="6" class="text-center">Nenhum arquivo informado.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="hr-line-dashed margin-top-5"></div>


        <!-- INFORMAÇÕES DE UMA VARIÁVEL -->

        <div class="row" v-if="configuracao.textoDeclaracaoResumoAceiteFornecedor">
          <div class="col-sm-12">
            <div v-html="configuracao.textoDeclaracaoResumoAceiteFornecedor" />
            <br />
          </div>
        </div>

        <!-- FINAL -->

        <div class="row">
          <div class="col-sm-12">
            <div class="form-group required" :class="{'has-error': errors.has('aceiteCheckbox')}">
              <div class="checkbox">
                <label>
                  <input id="aceiteCheckbox"
                         class="custom-checkbox remove-margin form-control "
                         type="checkbox"
                         v-model="responsavelAlteracao.aceite"
                         data-vv-name="aceiteCheckbox"
                         v-validate="'required'">
                  Eu, <b>{{ responsavelAlteracao.nome || '<< SEM NOME >>' }}</b>,
                  portador do documento CPF nº <b>{{ responsavelAlteracao.cpf || '<< SEM CPF >>' }}</b>
                  e contato de e-mail <b>{{ responsavelAlteracao.email || '<< SEM EMAIL >>' }}</b>,
                  estou ciente e atesto as informações aqui apresentadas.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style>
    .panel-resposta {
      background: transparent !important;
      padding-left: 10px;
      padding-right: 10px;
      border-width: 1px;
      border-color: lightgray;
      border-radius: 3px;
      border-style: solid;
      margin-left: 15px;
      margin-right: 15px;
      margin-bottom: 15px;
    }

    .form-group-resposta {
      margin-bottom: 0px;
    }

  .custom-checkbox {
    width: 14px;
    height: 14px;
  }

  .custom-checkbox.remove-margin {
    margin-top: 2px;
  }

</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/compartilhado/FormResumoAceite.vue